import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import Tooltip from "@mui/material/Tooltip";
import { Modal, Box, Typography, IconButton } from "@mui/material";
import EditButton from "components/table/EditButton";
import ViewModal from "components/modal/ViewFranchiseAllotmentModal";

import FranchiseAllotButton from "components/table/FranchiseAllotButton";
import ItineraryModal from "components/form/ItineraryModal";

import React, { useState } from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import RemarkModal from "components/modal/RemarkModal";
import { FiFile } from "react-icons/fi";
import { MdClose } from "react-icons/md"; // Import MdClose from react-icons
import FranchiseAllotDrawer from "components/drawer/FranchiseAllotDrawer";
import FranchiseAllotEditButton from "components/table/FranchiseAllotEditButton";
// internal imports

const FranchiseAllotTable = ({
  franchisealot,
  perpage,
  currentPage,
  tab,
  hideAdd,
  hideEdit
}) => {
  const {
    title,
    serviceBlock,
    start_date,
    end_date,
    franchise_id,
    latest_va_id,
    franchise_name,
    days,
    serviceId,
    handleModalOpen,
    handleFranchiseUpdate,
    PackageType,
    faVendorIsAllot,
    is_Franchise_driver_vehicle_alloted,
    franchiseAction,
    clientArrived,
    tripWentOrNot,
  } = useToggleDrawer();
  const [open, setOpen] = useState(false);
  const [selectedRemark, setSelectedRemark] = useState("");
  const [itinerary, setItinerary] = useState("");
  const [showItineraryModal, setShowItineraryModal] = useState(false);
  const handleOpen = (remark) => {
    if (/<[a-z][\s\S]*>/i.test(remark)) {
      // If the content has HTML tags
      setSelectedRemark(<div dangerouslySetInnerHTML={{ __html: remark }} />);
    } else {
      // If the content is plain text
      setSelectedRemark(remark);
    }
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  // const franchiseEnddate=
  // franchisealot?.[0]?.franchise_history?.find(
  //   item => item.status === "Present"
  // )?.start_date || null;
  return (
    <>
      <RemarkModal
        id_data={serviceId}
        block_data={serviceBlock}
        title_data={title}
      ></RemarkModal>
      <DeleteModal id={serviceId} title={title} />
      <ViewModal id={serviceId} title={title} data={franchisealot} />
      <MainDrawer>
        <FranchiseAllotDrawer
          id={serviceId}
          start_date={start_date}
          end_date={end_date}
          latest_va_id={latest_va_id}
          tab={tab}
          franchise_id={franchise_id}
          franchise_name={franchise_name}
          days={days}
          package_type={PackageType}
          faVendorIsAllot={faVendorIsAllot}
          is_Franchise_driver_vehicle_alloted={
            is_Franchise_driver_vehicle_alloted
          }
          franchiseAction={franchiseAction}
          clientArrived={clientArrived}
          tripWentOrNot={tripWentOrNot}
        />
      </MainDrawer>

      <TableBody>
        {franchisealot?.slice(0, perpage).map((data, index) => {
          const presentFranchise = data.franchise_history?.find(
            (f) => f.status === "Present",
          );
          const presentVendor = presentFranchise?.vendor_history?.find(
            (v) => v.status === "Present",
          );
          const presentDriver = presentVendor?.driver_vehicle_history?.find(
            (d) => d.status === "Present",
          );
          // Once ANY driver/vehicle assignment across this booking's whole
          // history was confirmed Went, the trip genuinely happened — a
          // later reassignment's own outcome (even "Not Went") can't undo
          // that fact. Read from the server-computed `ever_went` flag
          // (models/franchiseAllotmentModel.js) rather than the nested
          // history JSON here — that JSON only carries the CURRENT
          // driver/vehicle assignment per stint, so an earlier confirmed-Went
          // leg swapped away from within the same vendor is invisible to it.
          const everWent = data.ever_went === true;
          return (
            <TableRow
              key={index}
              className={data.status === 1 ? "bg-red-100" : ""}
            >
              <TableCell className="text-center text-sm">
                {(currentPage - 1) * perpage + index + 1}
                {/* {    console.log(data)} */}
              </TableCell>
              <TableCell className="text-center text-sm">
                {data.ref_no}
              </TableCell>
              <TableCell className="text-center text-sm">
                {data.client_name}
              </TableCell>

              <TableCell className="text-center text-sm">
                {data.no_of_days}
              </TableCell>

              <TableCell className="text-center text-sm">
                <div className="flex flex-col gap-3">
                  <span className="text-sm text-teal-500">
                    {data?.arrival_name}
                  </span>
                  <span className="text-sm text-yellow-700">
                    {data?.departure_name}
                  </span>
                </div>
              </TableCell>

              <TableCell className="text-center text-sm">
                {data.package_type}
              </TableCell>
              <TableCell className="text-center text-sm">
                {data?.itinerary ? (
                  <span className="text-sm cursor-pointer flex justify-center items-center">
                    <span
                      onClick={() => {
                        setShowItineraryModal(true);
                        setItinerary(data.itinerary);
                      }}
                      title="Itinerary"
                    >
                      <FiFile className="text-2xl text-green-500 hover:text-green-600" />
                    </span>
                  </span>
                ) : (
                  <span className="text-sm cursor-pointer flex justify-center items-center">
                    -
                  </span>
                )}
              </TableCell>

              <TableCell>
                <span className="text-sm">{data.start_date}</span>
                <br />
                <span className="text-sm">{data.end_date}</span>
              </TableCell>

              {(tab === 1 || tab === 2) && (
                <TableCell className="text-center text-sm mb-1">
                  {[...(data.franchise_history || [])].map(
                    (franchise, index) => (
                      <div key={index}>
                        <p
                          className={`text-sm mb-1 ${
                            franchise.status === "Present"
                              ? "text-black"
                              : "text-red-600"
                          }`}
                        >
                          {franchise.franchise_name || "-"}
                        </p>
                      </div>
                    ),
                  )}
                </TableCell>
              )}

              {(tab === 1 || tab === 2) && (
                <TableCell className="text-center text-sm">
                  {(data?.franchise_history || []).map((franchise, index) => (
                    <div
                      key={franchise.id || index}
                      className={`mb-1 text-sm cursor-pointer ${
                        franchise.status === "Present"
                          ? "text-black"
                          : "text-red-600"
                      }`}
                    >
                      {franchise?.trip_status_text === "Not Went"
                        ? franchise.trip_status_text
                        : `${franchise.start_date || "-"} - ${franchise.end_date || "-"}`}
                    </div>
                  ))}
                </TableCell>
              )}

              {(tab === 1 || tab === 2) && (
                <TableCell className="text-center mb-1 text-sm">
                  {[...(data.franchise_history || [])].map(
                    (franchise, index) => (
                      <div key={index}>
                        {franchise.status === "Present" ? (
                          <span>-</span>
                        ) : franchise.reason?.trim() ? (
                          <p
                            className="text-blue-500 mb-1 cursor-pointer"
                            onClick={() => handleOpen(franchise)}
                          >
                            Remark
                          </p>
                        ) : (
                          <span>-</span>
                        )}
                      </div>
                    ),
                  )}
                </TableCell>
              )}

              <TableCell className="text-center text-sm">
                {data.vehiclename}
              </TableCell>

              <TableCell className="text-center">
                {data.vehicle_note ? (
                  <span
                    className="text-sm text-blue-500 cursor-pointer"
                    onClick={() => handleOpen(data.vehicle_note)}
                  >
                    View
                  </span>
                ) : (
                  <span className="text-sm text-center">-</span>
                )}
              </TableCell>

              <TableCell className="text-center text-sm">
                <span
                  className={`px-2 py-1 rounded-full text-sm mb-0 font-semibold ${
                    data?.trip_status === "Upcoming"
                      ? "text-blue-700"
                      : data?.trip_status === "Ongoing"
                        ? " text-yellow-700"
                        : data?.trip_status === "Completed"
                          ? " text-green-700"
                          : data?.trip_status === "Cancelled"
                            ? " text-red-700"
                            : " text-gray-700"
                  }`}
                >
                  {data?.trip_status}
                </span>
              </TableCell>

              <TableCell className="text-center">
                {data.status === 1 ? (
                  <span>-</span>
                ) : hideEdit ? (
                  (() => {
                    const [sd, sm, sy] = data.start_date.split("-");
                    const [ed, em, ey] = data.end_date.split("-");

                    const startDate = new Date(`${sy}-${sm}-${sd}`);
                    const endDate = new Date(`${ey}-${em}-${ed}`);
                    const today = new Date();

                    startDate.setHours(0, 0, 0, 0);
                    endDate.setHours(0, 0, 0, 0);
                    today.setHours(0, 0, 0, 0);

                    // const canAllot =
                    //   // today <= startDate &&
                    //   data.franchise_status === "Unallotted" &&
                    //   (tab === 0 || tab === 2);

                    // const canEdit =
                    // //  today <= startDate &&
                    //   data.franchise_status === "Allotted" &&
                    //   (tab === 1 || tab === 2) && data?.trip_status !=="Completed";

                    const canAllot =
                      // today <= endDate &&
                      data.trip_status !== "Completed" &&
                      data.franchise_status === "Unallotted" &&
                      (tab === 0 || tab === 2);

                    const canEdit =
                      // today <= endDate &&
                      data.trip_status !== "Completed" &&
                      data.franchise_status === "Allotted" &&
                      (tab === 1 || tab === 2);

                    const isTab2 = tab === 2;

                    return canAllot ? (
                      <FranchiseAllotButton
                        id={data.id_client}
                        // franchiseid={data.franchise_id}
                        start_date={data.start_date}
                        end_date={data.end_date}
                        package_type={data.package_type}
                        handleFranchiseUpdate={handleFranchiseUpdate}
                        handleModalOpen={handleModalOpen}
                      />
                    ) : canEdit ? (
                      <FranchiseAllotEditButton
                        franchise_name={data.franchise_name}
                        franchise_id={data.franchise_id}
                        latest_va_id={data.latest_va_id}
                        id={data.id_client}
                        start_date={
                          presentDriver?.va_start_date ??
                          presentVendor?.start_date ??
                          presentFranchise?.start_date ??
                          data.start_date
                        }
                        end_date={
                          presentDriver?.va_end_date ??
                          presentVendor?.end_date ??
                          presentFranchise?.end_date ??
                          data.end_date
                        }
                        days_count={data.no_of_days}
                        package_type={data.package_type}
                        tab={tab}
                        handleFranchiseUpdate={handleFranchiseUpdate}
                        handleModalOpen={handleModalOpen}
                        is_vendor_alloted={data?.is_vendor_alloted}
                        is_driver_vehicle_alloted={
                          data?.is_driver_vehicle_alloted
                        }
                        franchiseAction="modify"
                        clientArrived={data?.is_client_arrived}
                        tripWentOrNot={
                          everWent ? "1" : presentDriver?.trip_went_or_not
                        }
                      />
                    ) : isTab2 ? (
                      <span
                        className={`text-sm ${
                          data.franchise_status === "Allotted"
                            ? "text-green-600"
                            : "text-red-600"
                        }`}
                      >
                        {data.franchise_status}
                      </span>
                    ) : (
                      <span>-</span>
                    );
                  })()
                ) : (
                  <span>-</span>
                )}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
      <ItineraryModal
        isOpen={showItineraryModal}
        content={itinerary}
        onClose={() => setShowItineraryModal(false)}
      />
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            maxWidth: "90%",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 2,
            borderRadius: 2,
          }}
        >
          {/* Close Icon */}
          <IconButton
            onClick={handleClose}
            sx={{ position: "absolute", top: 8, right: 8 }}
          >
            <MdClose size={24} />
          </IconButton>

          <Typography variant="h5" sx={{ mb: 2 }}>
            Remark Details
          </Typography>

          <Typography
            variant="body1"
            sx={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
          >
            {/* <p>
              <span style={{ fontWeight: 600 }}>Franchise Name:</span>{" "}
              {selectedRemark?.franchise_name}
            </p>
            <p>
              <span style={{ fontWeight: 600 }}>Start Date:</span>{" "}
              {selectedRemark?.start_date}
            </p>
            <p>
              <span style={{ fontWeight: 600 }}>End Date:</span>{" "}
              {selectedRemark?.end_date}
            </p> */}
            <p>
              <span style={{ fontWeight: 600 }}>Reason:</span>{" "}
              {selectedRemark?.reason}
            </p>
          </Typography>
        </Box>
      </Modal>
    </>
  );
};

export default FranchiseAllotTable;
